import React, { Component } from "react";

import { Header, Table, Icon, Popup, Button, Input } from "semantic-ui-react";

import { backendPhoneNumberToDisplay } from "../util/phone";

import { connect } from "react-redux";

import {
  deleteSubmitter,
  submitterRemoved,
  addSubmitter,
  submitterAdded
} from "../actions/reimbursements";

class _RemoveButton extends Component {
  constructor() {
    super();

    this.state = {
      submitting: false,
      confirming: false,
      timeoutID: null
    };
  }

  onClick = event => {
    event.stopPropagation();
    if (!this.state.confirming) {
      this.setState({
        confirming: true,
        timeoutID: setTimeout(() => {
          clearInterval(this.state.timeoutID);
          this.setState({
            confirming: false
          });
        }, 2000)
      });
      return;
    }
    this.setState({
      submitting: true
    });
    const uuid = this.props.submitter.uuid;
    deleteSubmitter(uuid)
      .then(() => {
        clearInterval(this.state.timeoutID);
        this.props.removeSubmitter(uuid);
      })
      .catch(() => {
        this.setState({
          submitting: false,
          confirming: false
        });
      });
  };

  render() {
    if (this.state.confirming) {
      return (
        <Button
          negative
          size="tiny"
          loading={this.state.submitting}
          onClick={this.onClick}
        >
          Are you sure?
        </Button>
      );
    } else {
      return (
        <Button
          basic
          size="tiny"
          loading={this.state.submitting}
          onClick={this.onClick}
        >
          Remove Submitter
        </Button>
      );
    }
  }
}

const removeButtonMapDispatchToProps = dispatch => {
  return {
    removeSubmitter: uuid => dispatch(submitterRemoved(uuid))
  };
};

const RemoveButton = connect(
  null,
  removeButtonMapDispatchToProps
)(_RemoveButton);

class _AddForm extends Component {
  constructor() {
    super();

    this.state = {
      email: "",
      submitting: false,
      error: false
    };
  }

  handleChange = event => {
    this.setState({
      email: event.target.value,
      error: false
    });
  };

  handleSubmit = () => {
    this.setState({
      submitting: true
    });
    addSubmitter(this.state.email)
      .then(newSubmitter => {
        this.props.storeAddSubmitter(newSubmitter);
        this.setState({
          email: ""
        });
      })
      .catch(e => {
        this.setState({
          error: true
        });
      })
      .finally(() => {
        this.setState({
          submitting: false
        });
      });
  };

  checkInvalid = () => {
    return (
      !this.state.email.match(/.+@.+\..+/g) ||
      this.props.checkExists(this.state.email)
    );
  };

  render() {
    return (
      <Input
        onChange={this.handleChange}
        disabled={this.state.submitting}
        value={this.state.email}
        action={{
          primary: true,
          content: "Add submitter",
          onClick: this.handleSubmit,
          disabled: this.checkInvalid(),
          loading: this.state.submitting
        }}
        placeholder="E-mail address"
        icon="at"
        type="email"
        iconPosition="left"
      />
    );
  }
}

const addFormMapStateToProps = state => {
  return {
    checkExists: email =>
      !!state.reimbursements.submitters.find(
        submitter => submitter.email === email
      )
  };
};

const addFormMapDispatchToProps = dispatch => {
  return {
    storeAddSubmitter: newSubmitter => dispatch(submitterAdded(newSubmitter))
  };
};

const AddForm = connect(
  addFormMapStateToProps,
  addFormMapDispatchToProps
)(_AddForm);

const SubmitterTable = props => (
  <Table compact celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell rowSpan="2">Person</Table.HeaderCell>
        <Table.HeaderCell colSpan="3">Can submit via:</Table.HeaderCell>
        <Table.HeaderCell rowSpan="2" />
      </Table.Row>
      <Table.Row>
        <Table.HeaderCell
          style={{ width: "6em", borderLeft: "1px solid rgba(34,36,38,.1)" }}
          textAlign="center"
        >
          E-mail
        </Table.HeaderCell>
        <Table.HeaderCell style={{ width: "6em" }} textAlign="center">
          Text
        </Table.HeaderCell>
        <Table.HeaderCell style={{ width: "6em" }} textAlign="center">
          Slack
        </Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {props.people.map(submitter => (
        <Table.Row key={submitter.uuid}>
          <Table.Cell>
            <Header as="h5">
              <Icon name="user" color={!!submitter.name ? "black" : "grey"} />
              <Header.Content>
                {submitter.name || submitter.email}
                {submitter.name && (
                  <Header.Subheader>{submitter.email}</Header.Subheader>
                )}
              </Header.Content>
            </Header>
          </Table.Cell>
          <Table.Cell textAlign="center">
            {!submitter.is_email_confirmed && (
              <Popup
                size="small"
                inverted
                trigger={
                  <Icon color="grey" inverted name="checkmark" size="large" />
                }
                content="E-mail not yet verified."
              />
            )}
            {submitter.is_email_confirmed && (
              <Popup
                size="small"
                inverted
                trigger={<Icon color="green" name="checkmark" size="large" />}
                content="E-mail verified"
              />
            )}
          </Table.Cell>
          <Table.Cell textAlign="center">
            {submitter.phone &&
              submitter.is_phone_confirmed && (
                <Popup
                  size="small"
                  inverted
                  trigger={<Icon color="green" name="checkmark" size="large" />}
                  content={backendPhoneNumberToDisplay(submitter.phone)}
                />
              )}
            {submitter.phone &&
              !submitter.is_phone_confirmed && (
                <Popup
                  size="small"
                  inverted
                  trigger={
                    <Icon color="grey" name="checkmark" size="large" inverted />
                  }
                  content="Phone number not yet verified."
                />
              )}
          </Table.Cell>
          <Table.Cell textAlign="center">
            {!!submitter.slack && (
              <Popup
                size="small"
                inverted
                trigger={<Icon color="green" name="checkmark" size="large" />}
                content={"@" + submitter.slack.name}
              />
            )}
          </Table.Cell>
          <Table.Cell textAlign="center" collapsing>
            <RemoveButton submitter={submitter} />
          </Table.Cell>
        </Table.Row>
      ))}
      {props.people.length === 0 && (
        <Table.Row>
          <Table.Cell colspan="5">
            You haven't added anyone, so no one can submit reimbursements. Add
            emails below.
          </Table.Cell>
        </Table.Row>
      )}
    </Table.Body>
    <Table.Footer>
      <Table.Row>
        <Table.HeaderCell textAlign="left" colSpan="5" verticalAlign="middle">
          <div style={{ float: "right" }}>
            <AddForm />
          </div>
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  </Table>
);

export default SubmitterTable;



// WEBPACK FOOTER //
// ./frontend/src/components/SubmitterTable.js